// extracted by mini-css-extract-plugin
export var searchHeader = "_7e-0";
export var searchHeaderDark = "_7e-1";